<template>
  <v-container id="smslogs" fluid tag="section">
    <v-row>
      <v-col cols="12" sm="12"
        md="12"
        lg="12">
        
        <v-card>
        <v-card-text style="color: #509bb0; padding: 5px 15px 0px">
          <!-- <v-row>
            <v-col cols="12" md="3" lg="3">
                <z-month-picker
                :label="$i18n.t('For Month')"
                v-model="filters.forMonth"
                />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2" class="text-right" style="align-self: center;">
                <v-btn
                color="success"
                class="mr-3"
                fab
                x-small
                dark
                @click="search()"
                :loading="loading"
                >
                <v-icon>mdi-magnify</v-icon>
                </v-btn>

                <v-btn
                color="orange"
                class="mr-3"
                fab
                small
                dark
                @click="download()"
                :loading="loading"
                >
                <v-icon>mdi-cloud-download</v-icon>
                </v-btn>
            </v-col>
          </v-row> -->
          <v-simple-table fixed-header dense  style="width: 100%">
            <thead>
              <tr>
                <th class="bold">
                  {{ $i18n.t("SR.#") }}
                </th>
                <th class="bold">
                  {{ $i18n.t("Reg. No") }}
                </th>
                <th class="bold">
                  {{ $i18n.t("Vehicle Type") }}
                </th>
                <th class="bold">
                  {{ $i18n.t("Notification") }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(report, index) in tripRevenueReports.rows" :key="index">
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  <router-link :to="'/vehicle/' + report.vehicle._id" v-if="$ha(270)" class="my-5">
                    {{ report.vehicle.regNo }}
                </router-link>
                </td>
                <td>{{ report.vehicle.vehType }}</td>
                <td>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small text >
                          {{getNotifyHeading(report.notifications)}} <v-icon>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <b>{{report.vehicle.regNo}}</b>
                      </v-list-item>
                      <v-list-item href="" v-for="(k, v) in report.notifications" :key="v + index">
                        <v-icon>mdi-circle-medium</v-icon>   <v-list-item-title>{{v}}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </tbody>
          </v-simple-table>

          <v-container>
            <v-pagination
              v-model="tripRevenueReports.page"
              class="my-4"
              :length="tripRevenueReports.total"
              total-visible="10"
              @input="search"
            ></v-pagination>
          </v-container>
        </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doGetWithDownload } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class VehicleExpenseStats extends Vue {
  tripRevenueReports = [];
  webcontent = {};
  url = "/api/vehicle/grid?forExpenseReport=true&forMonth=:month&sord=asc&sidx=_id";
  filterUrl = "/api/vehicle/grid?forExpenseReport=true&forMonth=:month&sord=asc&sidx=_id";
  download_filterUrl = "";
  download_url = "/api/report/trip/vehicle/revenue/formonth/:month/download?&";
  filters = {
    forMonth: null
  };
  rows = 20;
  page = 1;
  prevMonth = null;
  prevPrevMonth = null;

  // prepareUrl(_url) {
  //   let url = "";
  //   if (this.filters.podDateFrom)
  //     url = url + "&podDateFrom=" + this.filters.podDateFrom;
  //   if (this.filters.podDateTill)
  //     url = url + "&podDateTill=" + this.filters.podDateTill;
  //   if (this.filters.client_id)
  //     url = url + "&corp_id=" + this.filters.client_id;
  //   if (this.filters.entity_id)
  //     url = url + "&vendorEntity_id=" + this.filters.entity_id;
  //   if (this.filters.status) url = url + "&status=" + this.filters.status;
  //   if (this.filters.groupByDate)
  //     url = url + "&groupByDate=" + this.filters.groupByDate;
  //   if (this.filters.groupByEntity == true) url = url + "&groupByEntity=true";
  //   if (this.filters.groupByClient == true) url = url + "&groupByClient=true";
  //   return _url + url;
  // }

  async search(page) {
    if (!this.filters.forMonth) {
      common.setError("Provide month");
      return;
    }
    if (!page) page = 1;
    this.page = page;
    // const date1 = new Date(
    //   this.formatIntegerDate_MMDDYYYY(this.filters.podDateFrom, "/")
    // );
    // const date2 = new Date(
    //   this.formatIntegerDate_MMDDYYYY(this.filters.podDateTill, "/")
    // );
    // const diffTime = Math.abs(date2 - date1);
    // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    // if (diffDays > 184) {
    //   common.setError("Provide dates within range of 6 months");
    //   return;
    // }

    // this.filterUrl = this.prepareUrl(this.url);
    common.setLoading(true);
    try {
      const response = await doGet(this.filterUrl.replace(':month', this.filters.forMonth) + "&rows=" + this.rows + "&page=" + page );
      this.tripRevenueReports = response;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async download() {
    if (!this.filters.podDateFrom || !this.filters.podDateFrom) {
      common.setError("Provide dates");
      return;
    }
    const date1 = new Date(
      this.formatIntegerDate_MMDDYYYY(this.filters.podDateFrom, "/")
    );
    const date2 = new Date(
      this.formatIntegerDate_MMDDYYYY(this.filters.podDateTill, "/")
    );
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 184) {
      common.setError("Provide dates within range of 6 months");
      return;
    }

    // this.download_filterUrl = this.prepareUrl(this.download_url);
    common.setLoading(true);
    try {
      await doGetWithDownload(this.download_filterUrl);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async mounted() {
    // const d = new Date();
    // const year = d.getFullYear();
    // let day = d.getDate();
    // let month = d.getMonth() + 1;
    // month = month < 10 ? "0" + month : month;
    // day = day < 10 ? "0" + day : day;
    // this.filters.podDateTill = year + "" + month + "" + day;
    const d = new Date();
    const year = d.getFullYear();
    // let day = d.getDate();
    let month = d.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    // day = day < 10 ? "0" + day : day;
    this.filters.forMonth = year + "" + month;
    this.search(this.page);
  }

  @Watch("filters.forMonth")
  onForMonthChange(forMonth) {
    if (forMonth) {
      this.search(this.page);
      forMonth = forMonth + "";
      const year = parseInt(forMonth.substring(0,4));
      let month = forMonth.substring(4,6);
      month = parseInt(month);
      if (month < 10) {
        month = "0" + month;
      }
      const date = year + "-" + month + "-01";
      let v1 = new Date(date);
      let v2 = new Date(date);
      v1.setMonth(v1.getMonth() - 1);
      v2.setMonth(v2.getMonth() - 2);
      v1 = v1.getMonth()+1;
      v2 = v2.getMonth()+1;
      const year1 = v1 > month ? year - 1 : year;
      const year2 = v2 > month ? year - 1 : year;
      this.prevMonth = year1 + "" + v1;
      this.prevPrevMonth = year2 + "" + v2;
    } else {
      this.prevMonth = null;
      this.prevPrevMonth = null;
    }
  }

  get loading() {
    return common.loading;
  }

  getFormattedDateOrMonth(intDate) {
    if (intDate && intDate > 999999) {
      return this.formatIntegerDate(intDate);
    }
    return this.formatIntegerMonth(intDate);
  }

  formatIntegerDate_MMDDYYYY(date, seperator) {
    if (date) {
      seperator = !seperator ? "-" : seperator;
      const dateStr = date.toString();
      return (
        dateStr.substring(4, 6) +
        seperator +
        dateStr.substring(6, 8) +
        seperator +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
  formatIntegerDate(date, seperator) {
    if (date) {
      seperator = !seperator ? "-" : seperator;
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        seperator +
        dateStr.substring(4, 6) +
        seperator +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
  monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  formatIntegerMonth(intMonth) {
    if (intMonth) {
      intMonth = intMonth.toString();
      if (intMonth.indexOf("-") == -1) {
        intMonth =
          this.monthsShort[parseInt(intMonth.substring(4, 6)) - 1] +
          " " +
          intMonth.substring(0, 4);
      }
    }
    return intMonth;
  }
  
  getNotifyHeading(notifications) {
    if (notifications) {
      const noti = Object.keys(notifications);
      if (noti && noti.length > 0) {
        for (let i=0;i<noti.length;i++) {
          if (notifications[noti[i]] == "1") {
            return noti[i];
          }
        }
      }
      if (noti && noti.length > 0) {
        return noti[0];
      }
      return "No Notifications";
    } else {
      return "No Notifications";
    }
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}

.v-card__subtitle,
.v-card__text {
  font-size: 14px;
}

.v-expansion-panel-header--active {
  background-color: aliceblue;
  min-height: 50px !important;
}

tbody:nth-child(even) {
  background: #fafafa;
}
.thead tr th {
  padding: 0 2px !important;
}
.bold {
  font-weight: 600;
}
</style>
